module.exports = __webpack_public_path__ + "img/working-process4.b9f30b42.png";